import React, { useState, useRef } from 'react';
import NavLocale from "../NavLocale/NavLocale";

const EditorLocale = ({
  className,
  currentLocale = undefined,
  languages = [],
  onLocale
}) => {
  if (!languages.length || languages.length === 1) {
    return null;
  }

  return React.createElement(NavLocale, {
    className: className,
    currentLocale: currentLocale,
    languages: languages,
    onLocale: onLocale
  });
};

export default EditorLocale;